export default __webpack_public_path__ + "static/media/QuestionMark.690d1298.svg";